/* eslint-disable no-console */
import {Col, Form, Select} from 'antd';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import React, {useEffect, useMemo, useState} from 'react';
import {useSearchParams} from 'react-router-dom';

import {ReactComponent as YearCalender} from '../../assets/yearCalender.svg';
import {CommonErrors, TF} from '../../constants/Common';
import {sortBy} from '../../shared/commonFunctions';
import {yearSelect} from '../../utils/FormUtils/yearSelect';
import Loader from '../Loader/Loader';
import {MYConfig, MYData} from '../MonthlyYearly/Interface/common';
import MonthlyYearlyDrawerForm from '../MonthlyYearly/MonthlyYearlyDrawerForm';

import {yearKeyLabel} from './Constants/IP/commonKeyLabel';
import {FafKey, FafLabel} from './Constants/Products/FafKeyLabel';
import {unitTypes} from './interface/unitChange';
import changeUnit from './Utils/changeUnit';

const fafForm: React.FC<{
  rawMaterialFilter: any;
  data: any;
  currentStep?: number;
  setFormSelectedYear: React.Dispatch<React.SetStateAction<string>>;
  setIsFormLoading: React.Dispatch<React.SetStateAction<boolean>>;
  isFormLoading: boolean;
}> = ({
  rawMaterialFilter,
  data,
  currentStep,
  setFormSelectedYear,
  setIsFormLoading,
  isFormLoading
}) => {
  const FormInstance = useFormInstance();
  const [searchParam] = useSearchParams();
  const {getFieldValue, setFields} = FormInstance;
  const {productFilter} = rawMaterialFilter;

  const yearFilter = yearSelect();

  const [productState, setProductState] = useState<any>(unitTypes.WEIGHT);

  useEffect(() => {
    setProductState(
      productFilter?.find((item: any) => {
        return (
          item.value ===
          (getFieldValue(FafKey.PRODUCT_ID) ?? data?.[FafKey.PRODUCT_ID])
        );
      })
    );
  }, [getFieldValue(FafKey.PRODUCT_ID)]);

  const monYear: MYConfig[] = useMemo(() => {
    return [
      {
        mainTitle: {
          key: FafKey.FUEL_SOLD,
          title: FafLabel.FUEL_SOLD
        },
        unit: changeUnit(productState?.state)
      }
    ];
  }, [productState]);

  return (
    <>
      {isFormLoading ? (
        <Loader />
      ) : (
        <>
          {currentStep === 0 && (
            <>
              <Col className="gutter-row">
                <Form.Item
                  name={yearKeyLabel.key}
                  label={yearKeyLabel.label}
                  labelCol={{span: 24}}
                  initialValue={searchParam.get('selectedYear')}
                >
                  <Select
                    placeholder={yearKeyLabel.label}
                    options={yearFilter}
                    suffixIcon={<YearCalender />}
                    disabled={data?._id !== undefined}
                    onChange={(e) => {
                      setFormSelectedYear(e);
                      setIsFormLoading(true);
                      if (getFieldValue(FafKey.PRODUCT_ID)) {
                        setFields([
                          {
                            name: FafKey.PRODUCT_ID,
                            errors: ['Please select facility again'],
                            value: undefined
                          }
                        ]);
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              <Col className="gutter-row">
                <Form.Item
                  name={FafKey.PRODUCT_ID}
                  rules={[
                    {
                      required: true,
                      message: CommonErrors.mandatory(FafLabel.PRODUCT_ID)
                    }
                  ]}
                  label={FafLabel.PRODUCT_ID}
                  labelCol={{span: 24}}
                >
                  <Select
                    disabled={data !== undefined}
                    className="select"
                    placeholder={`Choose ${FafLabel.PRODUCT_ID}`}
                    options={sortBy(productFilter, 'label', 'asc')}
                    onChange={(_, option: any) => {
                      setProductState(option);
                    }}
                  />
                </Form.Item>
              </Col>
            </>
          )}

          {currentStep === 1 && (
            <>
              <MonthlyYearlyDrawerForm
                config={monYear}
                data={getFieldValue(TF) as MYData[]}
              />
            </>
          )}
        </>
      )}
    </>
  );
};

export default fafForm;
